import { PAYMENT_PROVIDERS, OFFLINE_PAYMENT_METHODS } from "@/utils/Const";
import i18n from "@/i18n";

function getOfflinePaymentProvider(paymentMethod) {
  switch (paymentMethod) {
    case OFFLINE_PAYMENT_METHODS.paybill:
      return PAYMENT_PROVIDERS.paybill;
    case OFFLINE_PAYMENT_METHODS.bankTransfer:
      return PAYMENT_PROVIDERS.bankTransfer;
    case OFFLINE_PAYMENT_METHODS.pdq:
      return PAYMENT_PROVIDERS.pdq;
    case OFFLINE_PAYMENT_METHODS.cash:
    default:
      return PAYMENT_PROVIDERS.cash;
  }
}

function getOfflinePaymentTransactionLabel(paymentMethod) {
  switch (paymentMethod) {
    case OFFLINE_PAYMENT_METHODS.paybill:
      return i18n.t("checkout.paybillOrder");
    case OFFLINE_PAYMENT_METHODS.bankTransfer:
      return i18n.t("checkout.bankTransferOrder");
    case OFFLINE_PAYMENT_METHODS.pdq:
      return i18n.t("checkout.pdq");
    case OFFLINE_PAYMENT_METHODS.cash:
    default:
      return i18n.t("checkout.cashOrder");
  }
}

export function getProviderDetails(order) {
  let foundTransaction = order?.cashPayments?.find((payment) => payment?.succeededAt != null);
  const providerDetails = { provider: null, transactionId: null, msidsn: null };
  if (foundTransaction) {
    const paymentMethod = foundTransaction.paymentMethod || OFFLINE_PAYMENT_METHODS.cash;
    providerDetails.transactionId = foundTransaction.offlinePaymentReferenceId;
    providerDetails.provider = getOfflinePaymentProvider(paymentMethod);
  }
  else {
    foundTransaction = order?.safaricomMpesaRequests?.find((payment) => payment.resultCode == 0);
    if (foundTransaction) {
      providerDetails.transactionId = foundTransaction.merchantRequestId;
      providerDetails.provider = PAYMENT_PROVIDERS.safaricom;
      providerDetails.msidsn = foundTransaction.msidsn;
    }
    else {
      foundTransaction = order?.dpoPayments?.find((payment) => payment.resultCode == 0);

      if (foundTransaction) {
        providerDetails.transactionId = foundTransaction.transactionReference;
        providerDetails.provider = PAYMENT_PROVIDERS.dpo;
      }
      else {
        foundTransaction = order?.momoMtnPayments?.find((payment) => payment.resultCode == 0);

        if (foundTransaction) {
          providerDetails.transactionId = foundTransaction.transactionReference;
          providerDetails.provider = PAYMENT_PROVIDERS.mtn;
          providerDetails.msidsn = foundTransaction.msidsn;
        }
        else {
          let foundTransaction = order?.wholesalePayments?.find((payment) => payment?.succeededAt != null);

          if (foundTransaction) {
            providerDetails.transactionId = i18n.t("checkout.b2b");
            providerDetails.provider = PAYMENT_PROVIDERS.wholesale;
          }
        }
      }
    }
  }
  return providerDetails;
}